(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .directive('protocolCategoryTableRow', ProtocolCategoryTableRowFn);

    ProtocolCategoryTableRowFn.$inject = ['ItemTableService', 'ProtocolCategoryService', 'Alert', 'ProtocolCategory', '$filter'];

    function ProtocolCategoryTableRowFn(ItemTableService, ProtocolCategoryService, Alert, ProtocolCategory, $filter) {

        var directive = {
            link: link,
            restrict: 'A',
            replace: true,
            templateUrl: '/app/settings/administration/modules/protocolcategories/templates/protocol-category-table-row.template.html'

        };
        return directive;

        function link(scope, element, attrs) {
            // if editing -> this is the original backup
            var original = null;

            // edit item
            scope.edit = function () {
                original = ItemTableService.edit(scope.item);
            };

            // cancel editing -> show original
            scope.cancel = function () {
                if (original === null) {
                    ItemTableService.remove(scope.item.vmIndex);
                } //if
                else {
                    // replace original with current edited item
                    ItemTableService.replace(original, scope.item.vmIndex);
                    // remove backup
                    original = null;
                } // else
            };

            // deactivate item (remove from table if it is new)
            scope.deactivate = function () {
                ProtocolCategoryService.deleteCategory(scope.item.id).then(function (result) {
                    Alert.success(result.data);
                    // remove from list
                    ItemTableService.remove(scope.item.vmIndex);
                });
            };

            // save editing values
            scope.save = function () {
                ItemTableService.save(scope.item);
                // prepare for save
                var item = new ProtocolCategory();
                item.extend(scope.item);

                // save or update
                if (scope.item.id > 0) {
                    // update
                    ProtocolCategoryService.update(item.id, item).then(function (result) {
                        // replace current with edited one
                        scope.item.extend(result.data);
                        Alert.success("protocol category updated successfully");
                    });
                } // if
                else {
                    // save
                    ProtocolCategoryService.save(item).then(function (result) {
                        ItemTableService.remove(scope.item.vmIndex);
                        ItemTableService.put(result.data);

                        Alert.success("protocol category saved successfully");
                    }, function (error) {
                        // remove
                        ItemTableService.remove(scope.item.vmIndex);
                    });
                }
            };

            // move item up
            scope.moveUp = function () {
                move(true);
            };

            // move item down
            scope.moveDown = function () {
                move(false);
            };

            function move(up) {
                var idx = ItemTableService.items.indexOf(scope.item);
                var itemCount = ItemTableService.items.length;
                var other;
                if (up && idx > 0) {
                    other = ItemTableService.items[idx - 1];
                } else if (idx < itemCount - 1) {
                    other = ItemTableService.items[idx + 1];                    
                }

                if (other) {                    
                    reorder(scope.item, other);
                }                
            }

            function reorder(item, related) {

                return ProtocolCategoryService.reorder(item.id, related.id).then(function (result) {

                    // remove and put
                    ItemTableService.remove(item.vmIndex);
                    ItemTableService.remove(related.vmIndex);
                    ItemTableService.put(result.data[0]);
                    ItemTableService.put(result.data[1]);

                    ItemTableService.sort();

                    Alert.success('List reordered successfully');
                }).$promise;
            } // reorder

        }
    }
})();